const ViewMore         = document.querySelector( '.viewmore' );;
const ViewMoreButton   = document.querySelector( '.viewmore__button' );
let ViewMoreButtonText = '';
let tryAjaxFails       = 1;
let isLoading          = false;


function Constructor() {

    if ( ViewMoreButton ) {
        ViewMoreButtonText = ViewMoreButton.textContent;
        ViewMoreButton.addEventListener( 'click', onClickViewMore, false );
    }
}

function onClickViewMore(){
    if ( isLoading ) {
        return;
    }
    isLoading = true;

    ViewMoreButton.textContent = 'Cargando...';

    sendAjax(function( HTML ){
        let tempHtml = document.createElement( "div" );
        let previousSibling = getPreviousSiblings( ViewMore, filterTags, 1 )[0] || false;

        tempHtml.innerHTML = HTML;

        ViewMore.insertAdjacentHTML( 'beforebegin', HTML );

        //Si no hay mas elementos borramos el boton
        if( tempHtml.innerHTML === "" ){
            ViewMore.parentNode.removeChild( ViewMore );
        }else{
            ViewMoreButton.dataset.page++;
            isLoading = false;
            ViewMoreButton.textContent = ViewMoreButtonText;

            // Scrolleamos al último item que vió el usuario antes de
            // cargar más items.
            if( previousSibling ) {
               window.scrollTo( 0, previousSibling.offsetTop - 100 );
            }
        }
    }, function(){
        setTimeout(function(){
            tryAjaxFails++;
            onClickViewMore();
        }, ( tryAjaxFails * 2000 ) );
    });
}
function sendAjax( success, error ){
    let URL = ViewMoreButton.dataset.viewmore + "/" + ViewMoreButton.dataset.page;

    const request = new XMLHttpRequest();
    request.onreadystatechange = function() {
        if ( request.readyState == 4 && request.status == 200){
            success( request.responseText );
        } else if( request.readyState == 4 && request.status != 200 ){
            error();
        }
    }
    request.open( "GET", URL, true );
    request.send();

}

function filterTags( el ) {
    return el.nodeType === 1 && el.tagName !== 'SCRIPT' && el.tagName !== 'BODY' && el.tagName !== 'HTML';
}

function getPreviousSiblings ( el, filter, count ) {
    let siblings = [];

    if( count > 0 ) {
        let i = 0;
        while ( el = el.previousSibling ) {
            if ( !filter || filter( el ) ) {
                if( i < count ) {
                    siblings.push( el );
                }
                i++;
            }
        }
    } else {
        while ( el = el.previousSibling ) {
            if ( !filter || filter( el ) ) siblings.push( el );
        }
    }
    return siblings;
}

export default Constructor